import { NodeState, TOKEN_STATE } from 'libs/sdk/core/src/lib/types'

export const tokenAndNodesStatusTagTypeMap: {
  [key in TOKEN_STATE | NodeState]: { title: string; class?: string; tooltip?: string }
} = {
  [TOKEN_STATE.EXPIRED]: {
    title: 'Expired',
    class: 'danger',
    tooltip: 'Process expired based on the configured time limit.',
  },
  [TOKEN_STATE.ABORTED]: {
    title: 'Aborted',
    tooltip: 'Token was aborted to a Back in Steps action; a new token was started.',
  },
  [TOKEN_STATE.ACTIVE]: {
    title: 'Active',
    class: 'primary',
    tooltip: 'Token is currently active and progressing through the process.',
  },
  [TOKEN_STATE.ON_HOLD]: {
    title: 'On Hold',
    class: 'primary',
    tooltip: 'Token is paused at a parallel gateway, waiting for all parallel branches to finish.',
  },
  [TOKEN_STATE.INACTIVE]: {
    title: 'Inactive',
    class: 'success',
    tooltip: 'Token has completed its path.',
  },
  [TOKEN_STATE.DISMISSED]: {
    title: 'Dismissed',
    tooltip: 'Token was cancelled or exited before completion.',
  },
  [TOKEN_STATE.TERMINATED]: {
    title: 'Terminated',
    class: 'danger',
    tooltip: 'Token was forcefully ended before completion.',
  },
  [NodeState.ARRIVED]: {
    title: 'Arrived',
    tooltip: 'Token was forcefully stopped due to a termination action.',
  },
  [NodeState.COMPLETED]: {
    title: 'Completed',
  },
  [NodeState.EXECUTED_COMPLETE]: {
    title: 'Executed Complete',
    tooltip: 'All mandatory actions on the node are completed.',
  },
  [NodeState.FAILED]: { title: 'Failed' },
  [NodeState.SCHEDULED_FOR_RETRY]: { title: 'Scheduled for Retry' },
  [NodeState.EXECUTED_PARTIAL]: {
    title: 'Executed Partial',
    tooltip: 'There are still mandatory uncompleted actions on this node.',
  },
  [NodeState.EXECUTING]: {
    title: 'Executing',
    tooltip: 'Token execution starts',
  },
  [NodeState.WAITING_MESSAGE_EVENT]: {
    title: 'Waiting',
    tooltip: 'Token reaches an intermediate message catch event node.',
  },
  [NodeState.WAITING_TIMER_EVENT]: {
    title: 'Waiting',
    tooltip: 'Token reaches an intermediate timer event node.',
  },
  [NodeState.WAITING_MESSAGE]: {
    title: 'Waiting',
    tooltip: 'Token waits for a message from another system.',
  },
  [NodeState.MESSAGE_RECEIVED]: {
    title: 'Message Received',
    tooltip: 'Message received.',
  },
  [NodeState.ERROR_MESSAGE_RECEIVED]: {
    title: 'Error',
  },
}
